/*
 * @Description: 
 * @Author: xgx
 * @Date: 2020-03-28 10:12:47
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-28 11:13:20
 */
import Vue from "vue";
// 这里去掉引入 去除默认样式，原因是 打包后会影响 elementUI 样式，
//但是在开发中发现不了问题，如果需要去除默认方式，请在代码中自行编写
//import "./assets/css/reset.css";  
import "./assets/fonts/xzmwfont/font.css";
import "./assets/fonts/iconfont/iconfont.css";
import "./assets/fontsTwo/remixicon.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from "./App.vue";
import router from "./router";
import echarts from "echarts";
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)
import VueQuillEditor from 'vue-quill-editor';
import { Boot } from "@wangeditor/editor";
import attachmentModule from "@wangeditor/plugin-upload-attachment";
import directive from './utils/directive';
Boot.registerModule(attachmentModule);
const options = {}; /* { default global options } */
Vue.use(VueQuillEditor, options); // options可选11
Vue.use(ElementUI);
Vue.use(Antd);
Vue.use(directive);
Vue.use(window['vue-cropper'].default);
Vue.prototype.$echarts = echarts;
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;
Vue.prototype.imgIp= process.env.VUE_APP_Img_Ip // 挂载图片ip
Vue.prototype.preview= process.env.VUE_APP_BASE_URL+'/' // 挂载图片ip

//路由权限校验
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token') || '';
  const menuData = JSON.parse(sessionStorage.getItem('menuData'));
  // 判断
  if(to.path == '/login'){
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userInfo');
    sessionStorage.removeItem('menuData');
    sessionStorage.removeItem('siteId');
    sessionStorage.removeItem('siteName');
    sessionStorage.removeItem('toWangZhan');
    token = sessionStorage.getItem('token') || '';
    next(); // 去登录页面
  }
  if (token) {
    let temp =menuData.filter(item=>{
          return to.name.split(',').includes(item)
      })
  
    if(to.path == '/index/403'){
      next(); 
    }else{
      if(temp.length > 0){
        next(); // 有权限放行
      }else{
        next("/index/403"); // 去无权限页
      }
    }
  } else {
    let url = window.location.href;
    if(url.indexOf('code') != -1){
        next(); // 第三方登录
    }else{
      next("/login"); // 去登录
    }
    
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
